<template>
  <div>
    <div :class="['search', scrollStick ? 'search_active' : '']">
      <div class="w search-box">
        <router-link
          to="/"
          @click.native="refresh"
          :title="common_info.store.name"
          ><img
            class="img-default search-img"
            :src="common_info.store.logo"
            :alt="common_info.store.name"
        /></router-link>
        <div class="search-c">
          <div class="search-item">
            <div class="box">
              <img
                class="img-default img"
                src="../../assets/images/search.png"
                alt
              />
              <input
                placeholder="搜索商品"
                class="search-input"
                type="text"
                v-model="searchtext"
                ref="searchtext"
                @focus="searchFocus"
                @blur="searchBlur"
              />
              <div v-if="records" class="history">
                <div
                  v-for="(item, index) in searchPast"
                  :key="index"
                  :class="[
                    'history_title',
                    searchTab == index ? 'historyActive' : '',
                  ]"
                  @click="pasttext(index)"
                  :data-index="index"
                  @mouseover="addActive(index)"
                  @mouseout="removeActive($event)"
                >
                  <p class="title_name">{{ item }}</p>
                  <p class="title_toast" v-if="searchTab != index">搜索历史</p>
                  <p class="title_del" v-else @click.stop="single_past(index)">
                    删除
                  </p>
                </div>
                <p class="del_past" @click="del_past">删除</p>
              </div>
            </div>
            <div class="search-btn" @click="searchshop()">搜索</div>
          </div>
          <ul
            class="search-default"
            v-if="common_info.store.search_hot_open && !scrollStick"
          >
            <li
              v-for="(item, index) in common_info.store.search_hot_content"
              :key="index"
            >
              <span @click="seachlist(item)" v-text="item"></span>
            </li>
          </ul>
        </div>
        <div class="cat" @click="cartgoto()">
          <img class="img-default xia" src="../../assets/images/cat.svg" alt />
          我的购物车
          <span v-text="carnum"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["seachcon", "catid"],
  data() {
    return {
      login: true,
      // common_info: {
      //   store: {
      //     search_hot_content: {},
      //   },
      // },
      searchtext: "", //搜索商品
      carnum: 0, //购物车数量
      records: false,
      searchPast: [],
      searchTab: "15",
      scrollStick: false,
    };
  },
  computed: {
    common_info() {
      let simulate = {
        store: {
          search_hot_content: {},
        },
      };
      let commonData = this.$store.state.common_info || simulate;
      return commonData;
    },
  },
  created() {
    let that = this;
    this.common.loginType(this);
    // this.common.getCommonInfo(this);
    if (!this.login) {
      this.cartnumapi();
    }
    window.addEventListener("scroll", this.scrollLoadMore);
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        if (that.$refs.searchtext.value) {
          that.searchshop();
        }
      }
    };
  },
  mounted() {
    this.searchtext = this.seachcon;
    if (JSON.parse(localStorage.getItem("historyList"))) {
      this.searchPast = JSON.parse(localStorage.getItem("historyList"));
    }
  },
  methods: {
    scrollLoadMore() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop, '滚动距离');
      var topNum = 666;
      let that = this;
      this.$nextTick(() => {
        // topNum = document.getElementsByClassName("scrollDetail")[0].offsetTop;
        if (scrollTop > topNum) {
          that.scrollStick = true;
        } else {
          that.scrollStick = false;
        }
      });
    },
    searchFocus() {
      if (this.searchPast && this.searchPast.length) {
        this.records = true;
      }
    },
    searchBlur() {
      let that = this;
      setTimeout(function () {
        that.records = false;
      }, 500);
      //
    },
    removehistory() {
      this.searchTab = "15";
    },
    pasttext(index) {
      this.searchtext = this.searchPast[index];
      this.records = false;
      this.searchshop(this.searchtext);
    },
    del_past() {
      this.searchPast = [];
      this.records = false;
      localStorage.setItem("historyList", JSON.stringify(this.searchPast));
    },
    addActive(index) {
      this.searchTab = index;
    },
    removeActive(e) {
      this.searchTab = "15";
      //   console.log(e);
    },
    single_past(index) {
      this.searchPast.splice(index, 1);
      localStorage.setItem("historyList", JSON.stringify(this.searchPast));
    },

    refresh() {
      this.$router.go(0);
    },
    // 购物车数量
    cartnumapi() {
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          this.$api
            .cartnum()
            .then((res) => {
              if (res.code == 0) {
                this.carnum = res.data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    cartgoto() {
      this.$router.push("/cat");
    },
    seachlist(text) {
      let searconter = this.$refs.searchtext.value;
      searconter = text;
      this.searchshop(searconter);
    },
    // 搜索商品
    searchshop(textcon) {
      let searchname = this.$refs.searchtext.value;
      if (textcon) {
        searchname = textcon;
      }
      if (searchname == "") {
        this.$message({
          showClose: true,
          message: "搜索商品不可为空",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
      } else {
        let parms = {
          keyword: searchname,
        };
        this.searchlocal(searchname);
        if (this.catid) {
          parms.id = this.catid;
        }
        this.$router.push({
          path: "/list",
          query: parms,
        });
      }
    },

    searchlocal(searchname) {
      if (!this.searchPast.includes(searchname)) {
        if (this.searchPast.length > 9) {
          this.searchPast.splice(this.searchPast.length - 1, 1);
        }
        this.searchPast.unshift(searchname);
        localStorage.setItem("historyList", JSON.stringify(this.searchPast));
      } else {
        //有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
        let i = this.searchPast.indexOf(searchname);
        this.searchPast.splice(i, 1);
        this.searchPast.unshift(searchname);
        localStorage.setItem("historyList", JSON.stringify(this.searchPast));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  height: 112px;
  background-color: #fff;
  width: 100%;

  .search-box {
    display: flex;
    height: 112px;
    padding-top: 32px;
    box-sizing: border-box;

    a {
      display: block;
      width: 187px;
      height: 55px;
    }

    .search-img {
      width: auto;
      height: auto;
      object-fit: fill;
      display: block;
      margin: 0 auto;
      max-width: 100%;
      max-height: 100%;
    }

    .search-c {
      margin-left: 113px;

      .search-item {
        display: flex;

        .box {
          width: 548px;
          height: 40px;
          border: 2px solid #ff0008;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          position: relative;

          .img {
            height: 16px;
            width: 16px;
            margin-left: 12px;
            margin-right: 4px;
          }

          .search-input {
            width: 100%;
            height: 36px;
            // border: 0 none;
            // box-sizing: border-box;
          }
          .history {
            position: absolute;
            left: 0px;
            top: 40px;
            z-index: 999;
            width: 548px;
            transition: all 0.3s;
            background: #fff;
            box-shadow: 1px 2px 1px rgb(0 0 0 / 20%);
            border: 1px solid #ccc;
            .history_title {
              padding: 5px 10px;
              font-size: 14px;
              cursor: pointer;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .title_name {
                color: #005aa0;
              }
              .title_toast {
                color: #ccc;
              }
              .title_del {
                color: #005aa0;
              }
            }
            .historyActive {
              background: rgb(0 0 0 / 10%);
            }
            .del_past {
              padding: 5px 0;
              margin: 0 10px;
              text-align: right;
              font-size: 16px;
              cursor: pointer;
              border-top: solid 1px #ccc;
            }
          }
        }

        .search-btn {
          width: 90px;
          height: 40px;
          background-color: #ff0008;
          color: #fff;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .search-default {
        display: flex;
        margin-top: 8px;

        li {
          margin-right: 8px;
          color: #b3b3b3;

          span {
            font-size: 12px;
            color: #b3b3b3;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            cursor: pointer;

            &:hover {
              color: #ff0e25;
            }
          }
        }
      }
    }

    .cat {
      height: 40px;
      width: 120px;
      border: 1px solid #ff0008;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ff0008;
      box-sizing: border-box;
      margin-left: 32px;
      cursor: pointer;
      border-radius: 2px;
      position: relative;

      span {
        position: absolute;
        top: 3px;
        left: 23px;
        right: auto;
        display: inline-block;
        padding: 1px 3px;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
        background-color: #e1251b;
        border-radius: 7px;
        min-width: 12px;
        text-align: center;
      }

      .xia {
        height: 18px;
        width: 18px;
        margin-right: 12px;
      }
    }
  }
}
.search_active {
  height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  animation: searchTop 0.5s ease-in-out;
  border-bottom: solid 1px #EDEBEB;
  .search-box {
    height: 56px;
    padding-top: 8px;
    a {
      width: 125px;
      height: auto;
    }
  }
}
@keyframes searchTop {
  0% {
    top: -50px;
  }
  100% {
    top: 0;
  }
}
</style>
